import { TicketCategory } from '@/types/enums';

function getTicketCategory(category: TicketCategory): string {
  if (category === TicketCategory.Cms) return 'CMS问题';
  if (category === TicketCategory.Cloud) return '网站云问题';
  if (category === TicketCategory.Theme) return '模板问题';
  if (category === TicketCategory.Extension) return '插件问题';
  return '其他';
}

export default getTicketCategory;
